<template>
  <div class="wrap">
    <img
      :src="require('@/assets/logo.png')"
      class="logo"
      @click="$router.push('/')"
    />
    <div class="bgImg">
      <div class="content">
        <div class="leftContent">
          <div class="leftImg">
            <div class="leftFont">{{ $t("login.logo.txt") }}</div>
          </div>
        </div>
        <div class="rightContent">
          <div class="loginTitle">
            <div>{{ $t("login.tit") }}</div>
          </div>
          <div class="loginTitleTwo">
            <div>{{ $t("login.txt") }}</div>
          </div>
          <el-form ref="form" :model="form" :rules="formRules">
            <el-form-item prop="loginName">
              <el-input
                v-model="form.name"
                placeholder="Your Email"
                class="inputStyleOne"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="form.password"
                placeholder="PASSWORD"
                show-password
                class="inputStyleTwo"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                class="loginBtn"
                @click="submitForm('form')"
              >
                {{ $t("header.login") }}
              </el-button>
            </el-form-item>
            <div class="loginBtmText">
              <div>
                {{ $t("login.tips") }} &nbsp;
                <div class="loginBtmFont" @click="signUp">
                  {{ $t("login.tips2") }}
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formRules: {
        password: [
          {
            required: true,
            message: "Please input your password!"
          }
        ]
      },
      form: {
        name: "",
        password: ""
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$message.success("Under Maintenance");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    signUp() {
      this.$message.success("Under Maintenance");
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  width: 100vw;
  height: 100vh;
}
.logo {
  position: fixed;
  top: 0px;
  left: 100px;
  width: 200px;
  cursor: pointer;
}

.bgImg {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  overflow: hidden;
  background: rgba(0, 82, 204, 0.05);
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  .leftContent {
    .leftImg {
      width: 620px;
      height: 632px;
      background-image: url("~@/assets/loginLeft.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .leftFont {
      font-size: 44px;
      font-weight: bold;
      color: #000000;
      line-height: 60px;
      // margin-left: 10px;
      padding-top: 51px;
      text-align: center;
    }
  }
  .rightContent {
    margin-left: 150px;
    padding: 10px 24px;
    width: 360px;
    height: 440px;
    background: #ffffff;
    box-shadow: 40px 80px 200px 0px rgba(0, 0, 0, 0.16);
    border-radius: 40px;
    .loginTitle {
      margin-top: 40px;
      font-size: 22px;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #171717;
      line-height: 30px;
      text-align: center;
    }

    .loginTitleTwo {
      margin-top: 12px;
      font-size: 14px;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #8f92a1;
      line-height: 20px;
      text-align: center;
    }
    /deep/.el-input__inner {
      border: none;
    }
  }
}

.loginBtn {
  width: 100%;
  height: 40px;
  background: #15b1a7;
  border-radius: 16px;
  font-size: 12px;
  font-family: Helvetica;
  color: #ffffff;
  line-height: 20px;
  border-color: #15b1a7;
}

.inputStyleOne {
  display: flex;
  align-items: center;
  margin-top: 40px;
  height: 46px;
  background: rgba(143, 146, 161, 0.05);
  border-radius: 16px !important;
  font-size: 14px;
  font-family: Helvetica;
  line-height: 24px;
  background-color: rgb(232, 240, 254) !important;
}

.inputStyleTwo {
  display: flex;
  align-items: center;
  height: 46px;
  background: rgba(143, 146, 161, 0.05);
  border-radius: 16px;
  font-size: 14px;
  font-family: Helvetica;
  line-height: 24px;
  background-color: rgb(232, 240, 254) !important;
  input {
    background-color: rgb(232, 240, 254) !important;
  }
}

.loginBtnOne {
  font-size: 12px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #0052cc;
  line-height: 18px;
  // float: right;
}

.loginBtmText {
  margin-top: 24px;
  font-size: 13px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: #8f92a1;
  line-height: 16px;
  text-align: center;
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    .loginBtmFont {
      font-size: 13px;
      font-family: Helvetica-Bold, Helvetica;
      font-weight: bold;
      color: #0052cc;
      cursor: pointer;
    }
  }
}

.codeInputWrap {
  text-align: center;
  .codeInput {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    opacity: 0;
  }
  .codeContainer {
    list-style: none;
    margin: 50px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    .fieldWrap {
      margin-right: 16px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 58px;
      height: 50px;
      background: #ffffff;
      box-shadow: 0px 1px 2px 0px rgba(184, 200, 224, 0.22);
      border-radius: 14px;
      border: 1px solid #d8e0f0;
      font-size: 24px;
      color: #7d8592;
      &:last-child {
        margin-right: 0;
      }
      &.highlight {
        border-color: #7d8592;
      }
      &.focus::after {
        content: "";
        position: absolute;
        top: 40px;
        left: 19px;
        width: 20px;
        height: 1px;
        background: #15b1a7;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/login.vue